import {preventDoubleClick} from '../global/_doubleClick'
export var callAddressAddFromUseAnyway = function(params, returnHTML) {
    function myCallback() {
        $(".modalDynamicRemove").remove();
        //For Steven's OneClick Stuff
        preventDoubleClick();
    }

    $.ajax({
        url: "/webapp/wcs/stores/servlet/AddressAddModalView",
        cache: false,
        type: "POST",
        data: "langId=-1&catalogId=301&storeId=301&firstName=" + $(".add-update-address-first-name").val() + "&lastName=" + $(".add-update-address-last-name").val() + "&address1=" + $(".av_address1").val() + "&address2=" + $(".av_address2").val() + "&city=" + $(".av_city").val() + "&state=" + $(".av_state").val() + "&zipCode=" + $(".av_zipCode").val() + "&orderId=" + $(".orderId").val() + "&addressUpdOrderItemId=" + $("#addressUpdOrderItemId").val() + "&callingPage=useAnyway",
        success: function(html) {
            returnHTML(html, myCallback);
            return false;
        }
    });
};
